import Register from ".";

export const RegisterRoutes = (data) => [
  {
    path: "/register",
    title: "register",
    layout: "auth",
    routeType: "auth",
    component: Register,
  },
];
